import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { RequestService } from "src/app/services/http-service.service";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  MENUITEMS = [];

  constructor(private router: Router, public request: RequestService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }

    this.updateMenu();
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  updateMenu() {

    this.MENUITEMS.push(
      //{ headTitle1: 'Verwalten' },
      { path: "/home", title: "Домашня сторінка", type: "link", bookmark: true},
      { path: "/drivers", title: "Водії", type: "link", bookmark: true},
      { path: "/users", title: "Пасажири", type: "link", bookmark: true},
      // { path: "/users", title: "Поїздки", type: "link", bookmark: true},
       { path: "/payments", title: "Платежі", type: "link", bookmark: true},
      { path: "/promos", title: "Знижки", type: "link", bookmark: true},
      { path: "/pricing", title: "Тарифи", type: "link", bookmark: true},
      { path: "/pushs", title: "Зв’язок", type: "link", bookmark: true},
      { path: "/application", title: "Додаток", type: "link", bookmark: true},
      { path: "/analytics", title: "Аналітика", type: "link", bookmark: true},
      { path: "/admins", title: "Адміністратори", type: "link", bookmark: true},
      //{ path: "/config", title: "Config", type: "link", bookmark: true }
    )

    console.log(this.MENUITEMS);

    // Array
    this.items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  }

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
